import DeclineOrderModal from './DeclineOrderModal';

export default DeclineOrderModal;
